import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Sparkles, Loader2, ChevronLeft } from 'lucide-react';

export default function WorkshopPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#181818]">
        <Loader2 className="w-6 h-6 animate-spin text-neutral-500" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#181818]" data-testid="workshop-auth-gate">
        <div className="text-center max-w-md mx-4">
          <Sparkles className="w-8 h-8 text-white mx-auto mb-4" strokeWidth={1.5} />
          <h2 className="text-2xl font-medium text-white mb-2">Sign in to access Workshop</h2>
          <p className="text-sm text-neutral-500 mb-6">Create a free account to start building with Codelves.</p>
          <button
            onClick={() => navigate('/?auth=register')}
            className="inline-flex items-center justify-center rounded-md bg-white text-black px-6 py-3 text-sm font-medium hover:bg-neutral-200 transition-colors"
            data-testid="workshop-signup-button"
          >
            Get Started Free
          </button>
          <p className="mt-3 text-xs text-neutral-600">
            Already have an account?{' '}
            <button
              onClick={() => navigate('/?auth=login')}
              className="text-neutral-400 hover:text-white underline underline-offset-2"
            >
              Sign in
            </button>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-[#181818] overflow-hidden" data-testid="workshop-page">
      {/* Slim nav bar — keeps branding visible and provides back navigation */}
      <div className="h-8 flex items-center gap-3 px-3 border-b border-white/[0.06] bg-[#0f0f0f] flex-shrink-0 z-10">
        <Link
          to="/"
          className="flex items-center gap-1 text-[10px] text-neutral-500 hover:text-white transition-colors font-mono"
          data-testid="workshop-nav-home"
        >
          <ChevronLeft className="w-3 h-3" />
          codelves
        </Link>
        <span className="text-[10px] text-neutral-700">|</span>
        <Link
          to="/workspace"
          className="text-[10px] text-neutral-500 hover:text-white transition-colors font-mono"
          data-testid="workshop-nav-workspace"
        >
          workspace
        </Link>
        <span className="text-[10px] text-neutral-700">|</span>
        <span className="text-[10px] text-white font-mono font-medium">workshop</span>
      </div>

      {/* Full-screen Codelves IDE iframe */}
      <iframe
        src="/codelves/index.html"
        className="flex-1 w-full border-0"
        title="Codelves Workshop IDE"
        data-testid="workshop-iframe"
        allow="cross-origin-isolated; clipboard-read; clipboard-write"
      />
    </div>
  );
}
